document.addEventListener('DOMContentLoaded', () => {
  const checkContainer = setInterval(() => {
    const container = document.querySelector('.instafeed-new-layout-wrapper');
    if (container) {
      clearInterval(checkContainer); // Stop checking once found
      setTimeout(() => {
        const newContainer = document.querySelector('.instafeed-new-layout-wrapper');
        initializeDragScroll(newContainer);
      }, 1000);
      
    }
  }, 100)

  const initializeDragScroll = (container) => {
    console.log(container);
    let isDragging = false;
    let startX, scrollLeft;
  
    container.addEventListener('mousedown', (e) => {
      isDragging = true;
      startX = e.pageX - container.offsetLeft;
      scrollLeft = container.scrollLeft;
      container.style.cursor = 'grabbing';
    });
    
    container.addEventListener('mouseleave', () => {
      isDragging = false;
      container.style.cursor = 'grab';
    });
    
    container.addEventListener('mouseup', () => {
      isDragging = false;
      container.style.cursor = 'grab';
    });
    
    container.addEventListener('mousemove', (e) => {
      if (!isDragging) return;
      e.preventDefault();
      const x = e.pageX - container.offsetLeft;
      const walk = (x - startX) * 2;
      container.scrollLeft = scrollLeft - walk;
    });
  }
});